import { render } from "./Practice.vue?vue&type=template&id=53f8294b&scoped=true"
import script from "./Practice.vue?vue&type=script&lang=js"
export * from "./Practice.vue?vue&type=script&lang=js"

import "./Practice.vue?vue&type=style&index=0&id=53f8294b&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f8294b"]])

export default __exports__